import { c as _c } from "react/compiler-runtime";
import { useState, useRef, useEffect, useCallback } from "react";
const HOVER_OPEN_DELAY = 150;
const HOVER_CLOSE_DELAY = 200;

/**
 * Manages mega menu hover/click state with delayed open/close logic.
 * Handles timeout-based hover interactions, escape key, and mobile menu toggle.
 */
export function useHeaderMenu() {
  const $ = _c(18);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeMenuId, setActiveMenuId] = useState(null);
  const openTimeoutRef = useRef(null);
  const closeTimeoutRef = useRef(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => () => {
      if (openTimeoutRef.current) {
        clearTimeout(openTimeoutRef.current);
      }
      if (closeTimeoutRef.current) {
        clearTimeout(closeTimeoutRef.current);
      }
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[2] !== activeMenuId) {
    t2 = () => {
      const handleEscape = e => {
        if (e.key === "Escape" && activeMenuId) {
          setActiveMenuId(null);
        }
      };
      document.addEventListener("keydown", handleEscape);
      return () => document.removeEventListener("keydown", handleEscape);
    };
    t3 = [activeMenuId];
    $[2] = activeMenuId;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = id => {
      if (openTimeoutRef.current) {
        clearTimeout(openTimeoutRef.current);
      }
      if (closeTimeoutRef.current) {
        clearTimeout(closeTimeoutRef.current);
      }
      setActiveMenuId(id);
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleOpenMenu = t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      if (openTimeoutRef.current) {
        clearTimeout(openTimeoutRef.current);
      }
      if (closeTimeoutRef.current) {
        clearTimeout(closeTimeoutRef.current);
      }
      setActiveMenuId(null);
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const handleCloseMenu = t5;
  let t6;
  if ($[7] !== activeMenuId) {
    t6 = id_0 => {
      if (closeTimeoutRef.current) {
        clearTimeout(closeTimeoutRef.current);
      }
      if (activeMenuId) {
        setActiveMenuId(id_0);
      } else {
        if (openTimeoutRef.current) {
          clearTimeout(openTimeoutRef.current);
        }
        openTimeoutRef.current = setTimeout(() => {
          setActiveMenuId(id_0);
        }, HOVER_OPEN_DELAY);
      }
    };
    $[7] = activeMenuId;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const handleTriggerMouseEnter = t6;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      if (openTimeoutRef.current) {
        clearTimeout(openTimeoutRef.current);
      }
      closeTimeoutRef.current = setTimeout(() => {
        setActiveMenuId(null);
      }, HOVER_CLOSE_DELAY);
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const handleTriggerMouseLeave = t7;
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      if (closeTimeoutRef.current) {
        clearTimeout(closeTimeoutRef.current);
      }
    };
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const handleShelfMouseEnter = t8;
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      closeTimeoutRef.current = setTimeout(() => {
        setActiveMenuId(null);
      }, HOVER_CLOSE_DELAY);
    };
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const handleShelfMouseLeave = t9;
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => {
      setMobileMenuOpen(_temp);
    };
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  const toggleMobileMenu = t10;
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => {
      setMobileMenuOpen(false);
    };
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  const closeMobileMenu = t11;
  let t12;
  if ($[14] !== activeMenuId || $[15] !== handleTriggerMouseEnter || $[16] !== mobileMenuOpen) {
    t12 = {
      mobileMenuOpen,
      toggleMobileMenu,
      closeMobileMenu,
      activeMenuId,
      handleOpenMenu,
      handleCloseMenu,
      handleTriggerMouseEnter,
      handleTriggerMouseLeave,
      handleShelfMouseEnter,
      handleShelfMouseLeave
    };
    $[14] = activeMenuId;
    $[15] = handleTriggerMouseEnter;
    $[16] = mobileMenuOpen;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  return t12;
}
function _temp(prev) {
  return !prev;
}